"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serializeStyles = exports.restoreFocusAfter = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var restoreFocusAfter = function restoreFocusAfter(callback) {
  var activeElement = document.activeElement;
  callback();

  if (activeElement) {
    activeElement.focus();
  }
};

exports.restoreFocusAfter = restoreFocusAfter;

var serializeStyles = function serializeStyles(styleMap) {
  if (typeof styleMap === 'string') return styleMap;
  if ((0, _typeof2.default)(styleMap) !== 'object') return '';
  var styles = '';
  Object.keys(styleMap).forEach(function (style) {
    styles += style + ": " + styleMap[style] + "; ";
  });
  return styles.trim();
};

exports.serializeStyles = serializeStyles;